import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";

const CustomerAddDeviceFormModel = ({ show, onClose, onSave, compId, customerId, deviceId, selectedRowDetails }) => {
  const [form, setForm] = useState({
    comp_id:  "",
    customer_id : "",
    mobile : "",
    callback_url : "",
  });
    const [ error, setError ] = useState({});

  const [validated, setValidated] = useState(false);
  const isEdit = !! deviceId;

    useEffect(() => {
      const fetchData = async () => {
        if (isEdit && show) {

          setForm({
            device_id: deviceId,
            comp_id:  compId,
            customer_id : customerId,
            mobile : selectedRowDetails.mobile,
            callback_url : selectedRowDetails.call_back_url,
          });
        }
      };
      fetchData();
    }, [deviceId, selectedRowDetails, show]);
  const handleSubmit = (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;

    if (formElement.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    onSave(form);
    onClose();
  }

  const handleChange = (e) => {
    const val = e.target.value;
    const name = e.target.name;
    
    
    if(val === ""){
      setForm((prev) => ({ ...prev, [name]: val }));
      return true;
    }
    if(name === 'mobile'){
      const numericVal = Number(val);
      if (/^\d*$/.test(numericVal)) {
        setForm((prev) => ({ ...prev, [name]: val }));
      }
    }

    if(name === 'callback_url') {
      setForm((prev) => ({ ...prev, [name]: val }));
    }
    if(name === 'device_status') {
      setForm((prev) => ({ ...prev, [name]: val }));
    } 
  }

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-light p-3">
            <h5 className="modal-title">{isEdit ? "Edit Device" : "Add Device"}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
					<form onSubmit={handleSubmit} 
					className={`tablelist-form needs-validation ${validated ? "was-validated" : ""}`}
					noValidate
					autoComplete="off">
						<div className="modal-body">
							<div className="row">
                {
                  isEdit && (
                    <div className="col-12">
											<div className="mb-3">
												<label className="form-label">Mobile Number</label>
												<input type="text" className="form-control-plaintext cursor-default bg-gray-100" value={form.mobile} readOnly />
											</div>
										</div>
                    
                  )
                }
                {
                  !isEdit && (
                    <div className="col-12">
                      <div className="mb-6">
                        <label for="phonenumberInput" className="form-label">Mobile Number</label>
                        <div class="input-group">
                            <span class="input-group-text" id="basic-addon1">91</span>
                            <input 
                              type="tel" 
                              name="mobile" 
                              className="form-control" 
                              placeholder="9999999999" 
                              inputMode="numeric" 
                              pattern="[0-9]{10}"
                              id="phonenumberInput" 
                              value={form.mobile} 
                              onChange={handleChange} 
                              required/>
                          
                            {error.mobile && <div className="invalid-feedback">{error.mobile}</div>}
                            </div>
                        </div>
                      </div>
                    
                  )
                }
								</div>
								<div className="col-12  mt-3">
									<div className="mb-6">
										<label for="personLastNameinput" className="form-label">Callback Url (Otional)</label>
										<input type="text" 
                    name="callback_url" 
                    className="form-control" 
                    placeholder="https://example.com/action" 
                    id="personLastNameinput" 
                    value={form.callback_url} 
                    onChange={handleChange} />
										{error.callback_url && <div className="invalid-feedback">{error.callback_url}</div>}
								</div>
								
								<div className="col-lg-12 mt-4">
									<div className="text-end">
										<button type="button" className="btn btn-light me-2" onClick={onClose}>
												Close
										</button>
										<button type="submit" className="btn btn-success">Submit</button>
									</div>
								</div>
							</div>
						</div>
					</form>
        </div>
      </div>
    </div>
  )
}
CustomerAddDeviceFormModel.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  customerId: PropTypes.string,
  compId: PropTypes.string,
};
export default CustomerAddDeviceFormModel